<jhi-spinner *ngIf="circleLoading"></jhi-spinner>
<div class="col-xl card-pg">
  <div class="card-wrapper">
    <div class="card card-bg">
      <div class="card-body">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/home">Home</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToServizi()">Servizi</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Pagare {{paymentNoticesService.mapCodiceTributo.get(cdTributo)}}</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Fine pagamento</a></li>
          </ol>
        </nav>
        <h4 class="text-center my-3 fw-bold">Esito del pagamento: {{statoPagamento}}</h4>
        <div class="row justify-content-center text-center">
          <div class="col-xl-8 col-lg-8 col-md-10 mb-3">
            <div class="card card-flex no-after rounded shadow-sm border border-light mb-0 font-philosopher px-3" style="justify-content: space-around;">
              <div class="card-image-wrapper with-read-more" *ngIf="tributo">
                <div class="card-body" style="min-height: 510.47px">
                  <h3 class="card-title h5">Dati
                    Pagamento</h3>
                  <div class="card border-black border-top">
                    <br><br>
                    <div class="form-group row">
                      <div class="col-6">
                        <label class="active">Tributo</label>
                        <input disabled readonly id="tributo" class="form-control" type="text" value="{{tributo.Tributo}}">
                      </div>
                      <div class="col-3">
                        <label class="active">Data scadenza</label>
                        <input disabled readonly id="data" class="form-control" type="text" value="{{tributo.Data | date: 'dd/MM/yyyy'}}">
                      </div>
                      <div class="col-3">
                        <label class="active">Tipo</label>
                        <input disabled readonly id="tipo" class="form-control" type="text" value="{{tributo.Tipo}}">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-12">
                        <label class="active">Descrizione</label>
                        <input disabled readonly id="descrizione" class="form-control" type="text" value="{{tributo.Descrizione}}">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-6">
                        <label class="active">Numero Avviso</label>
                        <input disabled readonly id="numero avviso" class="form-control" type="text" value="{{tributo.Numero}}">
                      </div>
                      <div class="col-6">
                        <label class="active">Importo totale</label>
                        <input disabled readonly id="CFUtente" class="form-control" type="text" value="{{tributo.Importo | currency: 'EUR'}}">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-auto">
            <div class="container mb-5">
              <form class="row" [formGroup]="ratingForm" *ngIf="!feedbackInviato; else nonInviato">
                <jhi-rating (ratingSelected)="onRatingSelected($event)"></jhi-rating>
                <div *ngIf="selectedRating > 0 && !inTextAreaPhase" class="question-container mt-5"
                     [ngClass]="{'less-bright': selectedRating <= 3}">
                  <jhi-question *ngIf="choices.length > 0" [question]="questionText" [choices]="choices"
                                (choiceSelected)="handleChoiceSelected($event)"></jhi-question>
                  <div class="button-container text-end mt-5">
                    <button class="back-button btn btn-primary primary-button" (click)="resetSelection()">Indietro
                    </button>
                    <button class="next-button submit-button btn btn-primary primary-button" (click)="showTextArea()"
                            [disabled]="ratingForm.get('primaRisposta')?.value === null && ratingForm.get('secondaRisposta')?.value === null">
                      Avanti
                    </button>
                  </div>
                </div>
                <div *ngIf="inTextAreaPhase" class="question-container mt-5">
                  <div class="textarea-question">
                    <p>Vuoi aggiungere altri dettagli?</p>
                    <textarea class="text-area" maxlength="200" formControlName="note"></textarea>
                  </div>
                  <div class="button-container text-end mt-5">
                    <button class="back-button btn btn-primary primary-button" (click)="backToChoices()">Indietro
                    </button>
                    <button class="submit-button btn btn-primary primary-button" (click)="submitQuestion()">Invia
                    </button>
                  </div>
                </div>
              </form>
              <ng-template #nonInviato>
                <div class="d-flex justify-content-center mt-3">
                <span class="fw-bold">Feedback inviato
                  <svg class="icon icon-success">
                    <use href="./content/svg/sprites.svg#it-check-circle"></use>
                  </svg>
                </span>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
